"use strict";

export default class TourCtrl {
  static get UID() {
    return "tourCtrl";
  }

  constructor(sceneFac, modelFac, siteConst, $filter) {
    "ngInject";
    Object.assign(this, { sceneFac, modelFac, siteConst, $filter });

    this.newestVideos = [];

    this.newestFilter = "latest";
    this.modelCount = this.siteConst.tour.models || 25;

    this.updatesCount = this.siteConst.tour.updates || 12;

    this.videoFilter(this.newestFilter);

    this.modelFac.getModels().then(response => {
      if (response.data.result === "success") {
        this.models = response.data.data;
      }
    });
  }

  videoFilter(filter) {
    if (
      filter === this.newestFilter &&
      Object.keys(this.newestVideos).length > 0
    ) {
      return;
    }

    this.newestFilter = filter;

    this.sceneFac.getScenes(this.updatesCount, filter).then(scenes => {
      this.newestVideos = scenes;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/features/tourCtrl.js